import React, { useEffect, useState } from 'react';
import W from '../../../components/common/Word';

const ActionTypes = {
  ADD: 'add',
  REMOVE: 'remove'
};

function FarmshopCartButton({ bundle_id, quantity, addToCartCallback, slug }) {
  const [value, setValue] = useState(quantity);

  useEffect(() => {
    setValue(quantity);
    updateProductGlobalState(bundle_id, quantity);
  }, [quantity]);

  function updateProductGlobalState(id, quantity) {
    window.dataLayer = window.dataLayer || [];
    window[`product_${id}`] = quantity;
  }

  function gtagEvent(eventType, params) {
    window.dataLayer.push(['event', eventType, params]);
  }

  const addtocart = async (action) => {
    let newVal = value;

    switch (action) {
      case ActionTypes.ADD:
        newVal++;
        break;
      case ActionTypes.REMOVE:
        if (newVal > 0) newVal--;
        break;
      default:
        break;
    }

    setValue(newVal);
    updateProductGlobalState(bundle_id, newVal);

    try {
      await addToCartCallback(bundle_id, newVal, action);
      if (action === ActionTypes.ADD) {
        gtagEvent('farmshop_add_to_cart', { meatcut: slug });
      } else if (newVal === 0) {
        gtagEvent('farmshop_remove_from_cart', { meatcut: slug });
      }
    } catch (error) {
      console.error('Error adding/removing from cart:', error);
    }
  };

  return (
    <div className={`quantity product-${bundle_id} ${value > 0 ? "enabled" : ""}`}>
      <a className="plus-btn farmshop-add-to-cart" role="button" onClick={() => addtocart(ActionTypes.ADD)}>
        <span><W>farmshop.btn</W></span>
        <i className='icon-plus'></i>
      </a>
      <span className='number'>
        <input type="text" value={value} disabled />
      </span>
      <a className="minus-btn" role="button" onClick={() => addtocart(ActionTypes.REMOVE)}>
        <i className='icon-minus'></i>
      </a>
    </div>
  );
}

export default FarmshopCartButton;